/* global ko */
import './index.less'

ko.components.register('progressbar', {
  viewModel: require('./progressbar/index').default,
  template: require('./progressbar/index.html')
})



// WEBPACK FOOTER //
// ./src/components/progressBar/index.js